/* TK Quote — Add to Quote + Request a Quote (posts cart to the tk-quote worker → Shopify draft order) */
(() => {
  if (window.__tkQuote) return;
  window.__tkQuote = true;

  const INTENT_KEY = "tkQuoteIntent";
  const root = document.documentElement;
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const money = (cents) => (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });

  /* ---------- Add to Quote: remember intent, highlight Request a Quote once the item lands ---------- */
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-tk-quote-add]")) sessionStorage.setItem(INTENT_KEY, String(Date.now()));
  }, true);

  // Any other submit button (Add to Cart) clears the intent.
  document.addEventListener("click", (e) => {
    const b = e.target.closest('button[type="submit"]');
    if (b && !b.matches("[data-tk-quote-add]") && b.form && b.form.matches('[is="product-form"], form[action*="/cart/add"]')) sessionStorage.removeItem(INTENT_KEY);
  }, true);

  const showIntent = () => {
    const t = Number(sessionStorage.getItem(INTENT_KEY) || 0);
    if (!t || Date.now() - t > 60000) return;
    sessionStorage.removeItem(INTENT_KEY);
    root.setAttribute("data-tk-quote-intent", "");
    setTimeout(() => {
      const cta = document.querySelector("cart-drawer[open] .tk-quote-cta, .tk-quote-cta");
      cta?.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }, 600);
    setTimeout(() => root.removeAttribute("data-tk-quote-intent"), 8000);
  };
  document.addEventListener("variant:add", () => setTimeout(showIntent, 50));
  if (document.readyState !== "loading") showIntent(); else document.addEventListener("DOMContentLoaded", showIntent);

  // Keep Add to Quote enabled/disabled in step with Add to Cart (variant changes, sold out).
  const syncButtons = () => {
    document.querySelectorAll("[data-tk-quote-add]").forEach((q) => {
      if (q.__tkSynced) return;
      const form = q.form;
      const atc = form && Array.from(form.elements).find((el) => el.type === "submit" && !el.matches("[data-tk-quote-add]"));
      if (!atc) return;
      q.__tkSynced = true;
      const apply = () => { q.disabled = atc.disabled; };
      apply();
      new MutationObserver(apply).observe(atc, { attributes: true, attributeFilter: ["disabled"] });
    });
  };
  if (document.readyState !== "loading") syncButtons(); else document.addEventListener("DOMContentLoaded", syncButtons);
  new MutationObserver(syncButtons).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Request a Quote dialog ---------- */
  const dlg = () => document.getElementById("tk-quote-dialog");
  let turnstileId = null;
  let cart = null;

  const loadTurnstile = (sitekey) => new Promise((resolve) => {
    if (!sitekey) return resolve(false);
    if (window.turnstile) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });

  const setError = (d, msg) => {
    const el = d.querySelector("[data-tk-quote-error]");
    el.textContent = msg || "";
    el.hidden = !msg;
  };

  const renderSummary = (d) => {
    const box = d.querySelector("[data-tk-quote-summary]");
    if (!cart || !cart.items.length) {
      box.innerHTML = "<strong>Your cart is empty.</strong> Add the parts you need, then request a quote.";
      return;
    }
    const rows = cart.items.map((i) => {
      const props = Object.entries(i.properties || {}).filter(([k, v]) => !k.startsWith("_") && v).map(([k, v]) => `<br><span class="text-subdued">${esc(k)}: ${esc(v)}</span>`).join("");
      return `<li>${i.quantity} &times; ${esc(i.product_title)}${i.variant_title ? " – " + esc(i.variant_title) : ""}${props}</li>`;
    }).join("");
    box.innerHTML = `<strong>${cart.item_count} item${cart.item_count === 1 ? "" : "s"} · ${money(cart.total_price)}</strong><ul>${rows}</ul>`;
  };

  const openDialog = async () => {
    const d = dlg();
    if (!d) return;
    d.querySelector('[data-tk-quote-step="form"]').hidden = false;
    d.querySelector('[data-tk-quote-step="done"]').hidden = true;
    setError(d, "");
    if (!d.open) d.showModal();
    try { cart = await (await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`)).json(); } catch { cart = null; }
    renderSummary(d);
    d.querySelector("[data-tk-quote-submit]").disabled = !(cart && cart.items.length);
    const sitekey = d.dataset.sitekey;
    if (await loadTurnstile(sitekey)) {
      const holder = d.querySelector("[data-tk-quote-turnstile]");
      if (turnstileId === null) turnstileId = window.turnstile.render(holder, { sitekey, appearance: "interaction-only" });
      else window.turnstile.reset(turnstileId);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    const d = dlg();
    const f = e.target;
    setError(d, "");
    const data = Object.fromEntries(new FormData(f).entries());
    if (!data.name?.trim()) return setError(d, "Please enter your name.");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((data.email || "").trim())) return setError(d, "Please enter a valid email.");
    if (!cart || !cart.items.length) return setError(d, "Your cart is empty.");
    if (!d.dataset.endpoint) return setError(d, "Quote requests aren't available right now. Please call us.");

    let token = "";
    if (window.turnstile && turnstileId !== null) {
      token = window.turnstile.getResponse(turnstileId) || "";
      if (!token) return setError(d, "Please wait for the verification check to finish, then submit again.");
    }

    const btn = d.querySelector("[data-tk-quote-submit]");
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");
    try {
      // Re-read the cart right before sending so the quote matches what they see.
      cart = await (await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`)).json();
      const payload = {
        ...data,
        turnstile_token: token,
        cart_note: cart.note || "",
        lines: cart.items.map((i) => ({ variant_id: i.variant_id, quantity: i.quantity, properties: i.properties || {} })),
      };
      const res = await fetch(d.dataset.endpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      const out = await res.json().catch(() => ({}));
      if (!res.ok || !out.ok) throw new Error(out.error || "Something went wrong. Please try again or call us.");
      d.querySelector('[data-tk-quote-step="form"]').hidden = true;
      d.querySelector('[data-tk-quote-step="done"]').hidden = false;
      d.querySelector("[data-tk-quote-done-msg]").innerHTML =
        `Thanks${data.name ? ", " + esc(data.name.split(" ")[0]) : ""}! ${out.name ? `Your quote reference is <strong>${esc(out.name)}</strong>. ` : ""}We'll email your quote to <strong>${esc(data.email)}</strong>.`;
      f.querySelector('[name="notes"]').value = "";
    } catch (err) {
      setError(d, err.message);
      if (window.turnstile && turnstileId !== null) window.turnstile.reset(turnstileId);
    } finally {
      btn.disabled = false;
      btn.removeAttribute("aria-busy");
    }
  };

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-tk-quote-open]")) { e.preventDefault(); openDialog(); }
    else if (e.target.closest("[data-tk-quote-close]")) dlg()?.close();
    // No backdrop-click close on purpose: a stray click would wipe a half-filled form. × button and Esc close it.
  });
  document.addEventListener("submit", (e) => { if (e.target.closest("#tk-quote-dialog")) submit(e); });
})();
